import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { DialogAgGridSearchComponent } from './dialog-ag-grid-search.component';

@NgModule({
  declarations: [DialogAgGridSearchComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
	ReactiveFormsModule,
	MatDialogModule,
	AgGridModule.withComponents([])
  ],
  exports: [DialogAgGridSearchComponent],
  entryComponents:[
	DialogAgGridSearchComponent
]
})
export class DialogAgGridSearchModule { }
